import type { IFocusOnReadingPositionOptions } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";

export const useFocusOnReadingPosition = () => {

    const focus = async (delayMs: number = 0, abortOnActiveDialogs: boolean = false, options?: IFocusOnReadingPositionOptions) => {
        setTimeout(() => {

            if(abortOnActiveDialogs && useUiBlockingGate().hasOpenOverlay.value) {
                return;
            }

            if(useUiBlockingGate().hasOpenBottomMenu) {
                return;
            }

            let delayMsAfterFocusOnReaderViewElement = 0;

            if (!useCirrusSharedAPI().appHasFocusWithin) {
                document.getElementById("reader-view-element")?.focus();
                delayMsAfterFocusOnReaderViewElement = 300;
            }

            setTimeout(()=>{
                useCirrusSharedAPI().focusOnReadingPosition(options);
            }, delayMsAfterFocusOnReaderViewElement);

        }, delayMs);
    }

    return {
        focus
    }
}
